import { BulkMemberSelection } from '../_types/bulk';

export type BulkMemberSelectionMode = 'location' | 'membership_ids' | 'user_emails' | 'user_ids';

interface BuildBulkMemberSelectionOptions {
  locationId?: number;
  mode: BulkMemberSelectionMode;
  servicePlanId?: number;
  values: Array<number | string>;
}

const getNumberValues = (values: Array<number | string>): number[] => {
  if (values.some(value => typeof value !== 'number')) {
    throw new Error('Expected a list of numeric IDs.');
  }

  return values as number[];
};

const getEmailValues = (values: Array<number | string>): string[] => {
  if (values.some(value => typeof value !== 'string')) {
    throw new Error('Expected a list of email addresses.');
  }

  return values as string[];
};

export const buildBulkMemberSelection = (
  options: BuildBulkMemberSelectionOptions,
): BulkMemberSelection => {
  if (options.mode === 'membership_ids') {
    return {
      membership_ids: getNumberValues(options.values),
    };
  }

  if (options.locationId === undefined) {
    throw new Error('A location is required for this selection mode.');
  }

  const locationSelection = {
    service_location_id: options.locationId,
    ...(options.servicePlanId === undefined
      ? {}
      : { service_plan_id: options.servicePlanId }),
  };

  switch (options.mode) {
    case 'user_ids':
      return {
        ...locationSelection,
        user_ids: getNumberValues(options.values),
      };
    case 'user_emails':
      return {
        ...locationSelection,
        user_emails: getEmailValues(options.values),
      };
    case 'location':
      return locationSelection;
    default:
      throw new Error(`Unsupported bulk member selection mode: ${options.mode}`);
  }
};
